import queryString from 'query-string'

import { toBase64 } from 'src/lib/js/base64'
import { TOAST_LOCAL_SEARCH_PATH } from 'src/public/js/siteUtilities'

import { resources } from 'config'

type SearchableLocation = {
  latitude?: number | null
  longitude?: number | null
  city: string
  state?: string
}

export const rxLocationSearchUrl = (
  location?: SearchableLocation,
  searchPath: string = TOAST_LOCAL_SEARCH_PATH
) => {
  return location?.latitude && location?.longitude
    ? `https://${
        resources.toastLocalHost
      }${searchPath}?${rxLocationToQueryString(location)}`
    : undefined
}

export const rxLocationToQueryString = (location: SearchableLocation) => {
  return queryString.stringify({
    filters: toBase64(
      JSON.stringify({
        userLat: location.latitude,
        userLong: location.longitude,
        userCity: location.city,
        userState: location.state
      })
    )
  })
}
